export const MOBILE_VERSION = "MOBILE_VERSION"

export const mobileVersion = (flag) => ({ type: MOBILE_VERSION, payload: { flag: flag } })
